import React from "react";
import { Box, Drawer, useMediaQuery, useTheme as useMuiTheme } from "@mui/material";
import { DrawerHeader } from "./DrawerHeader";
import { DrawerLoadingState } from "./DrawerLoadingState";
import { CategoriesMenu } from "./CategoriesMenu";
import { Category } from "../../../../types/Category";
import { LG } from "../../../../styles/liquidGlass";

interface CategoriesDrawerProps {
  isOpen: boolean;
  loading: boolean;
  error: string | null;
  rootCategories: Category[];
  productosOpen: boolean;
  expandedCategories: number[];
  onClose: () => void;
  onNavigate: (path: string) => void;
  onToggleProductos: () => void;
  onToggleCategory: (categoryId: number) => void;
  onCategoryClick: (category: Category) => void;
  onViewAllClick: (category: Category) => void;
  getSubcategories: (categoryId: number) => Category[];
}

export const CategoriesDrawer: React.FC<CategoriesDrawerProps> = ({
  isOpen,
  loading,
  error,
  rootCategories,
  productosOpen,
  expandedCategories,
  onClose,
  onNavigate,
  onToggleProductos,
  onToggleCategory,
  onCategoryClick,
  onViewAllClick,
  getSubcategories,
}) => {
  const muiTheme = useMuiTheme();
  const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down(900));

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
        BackdropProps: {
          sx: { backgroundColor: "rgba(10,10,10,0.25)", backdropFilter: "blur(4px)" },
        },
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2000,
        "& .MuiDrawer-paper": {
          background: LG.color.cream,
          borderRight: `1px solid ${LG.color.border}`,
          boxShadow: `8px 0 40px ${LG.color.shadow}`,
          width: 320,
        },
      }}
    >
      <Box sx={{ width: 320, height: "100%", display: "flex", flexDirection: "column" }} role="presentation">
        <DrawerHeader onClose={onClose} />
        <DrawerLoadingState loading={loading} error={error} />
        {!loading && !error && (
          <CategoriesMenu
            rootCategories={rootCategories}
            productosOpen={productosOpen}
            expandedCategories={expandedCategories}
            onNavigate={onNavigate}
            onToggleProductos={onToggleProductos}
            onToggleCategory={onToggleCategory}
            onCategoryClick={onCategoryClick}
            onViewAllClick={onViewAllClick}
            getSubcategories={getSubcategories}
            isMobile={isSmallScreen}
            onClose={isSmallScreen ? onClose : undefined}
          />
        )}
      </Box>
    </Drawer>
  );
};
